import { createFileRoute } from '@tanstack/react-router';
import { experimentsListOptions, toExperimentsQuery } from '@/features/experiments/api';
import { ExperimentsPage } from '@/features/experiments/ExperimentsPage';
import {
  EXPERIMENTS_SEARCH_DEFAULTS,
  ExperimentsSearch,
  stripDefaults,
} from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/experiments/')({
  validateSearch: ExperimentsSearch,
  search: { middlewares: [stripDefaults(ExperimentsSearch, EXPERIMENTS_SEARCH_DEFAULTS)] },
  loaderDeps: ({ search }) => search,
  // Préchargement ; les erreurs sont rendues par la page (`ErrorState`).
  loader: ({ context, deps }) =>
    context.queryClient
      .ensureQueryData(experimentsListOptions(toExperimentsQuery(deps)))
      .catch(() => undefined),
  component: ExperimentsPage,
});
